import axiosApi from "../../../components/Api/Axios";
import BackendServices from "../../../components/Api/BackendService";
import { FilterState } from "../index";
import { ReportFilter, ReportTemplate } from "../templates/templates";
import filterMappings from "../templates/filterMappings";

export default (
  template: ReportTemplate,
  filterValues: FilterState,
  format: "csv" | "xlsx"
) => {
  const params = Object.keys(filterValues).reduce<{}>((acc, curr) => {
    const mapper = filterMappings[curr as ReportFilter].mapToBody;
    return mapper ? { ...acc, ...mapper(filterValues) } : acc;
  }, {});

  const url = (() => {
    switch (format) {
      case "csv":
        return template.csvUrl;
      case "xlsx":
        return template.xlsUrl;
      default:
        throw new Error("Unsupported file format");
    }
  })();

  return axiosApi
    .get(`${BackendServices.REPORT_SERVICE.REPORT}/${url}`, {
      params,
      responseType: "blob",
      noGlobalError: true,
    })
    .then(({ data }) => {
      const downloadUrl = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.setAttribute(
        "download",
        `${template.name} - ${new Date().toLocaleString()}.${format}`
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
    })
    .catch(async (error) => {
      let errorText;
      try {
        errorText = await error.response.data.text();
      } catch (e) {
        errorText = null;
      }
      return Promise.reject(
        error.response?.status === 400 && errorText ? errorText : "Error"
      );
    });
};
